export const MENUS = [
  {
    text: 'Visão Geral',
    route: 'admin.index',
    icon: require('@/assets/icons/home.svg'),
  },
  {
    text: 'Vendas',
    icon: require('@/assets/icons/money.svg'),
    submenus: [
      { text: 'Listagem', route: 'sales.index' },
      { text: 'Importações', route: 'imports.index' },
    ],
  },
  {
    text: 'Cadastros',
    icon: require('@/assets/icons/users.svg'),
    submenus: [
      { text: 'Usuários', route: 'clients.index' },
      { text: 'Redes', route: 'network.index' },
      { text: 'Campanhas', route: 'campaign.index' },
      { text: 'Unidades', route: 'units.index' },
      { text: 'Produtos', route: 'products.index' },
      // { text: 'Cartões', route: 'cards.index' },
    ],
  },
  {
    text: 'Geral',
    icon: require('@/assets/icons/create.svg'),
    submenus: [
      { text: 'Banners', route: 'banners.index' },
      { text: 'Relatórios', route: 'reports.index' },
      { text: 'Destaque', route: 'featured-banners.index' },
      { text: 'Notícias', route: 'informatives.index' },
      { text: 'Regulamento', route: 'platform-regulations.index' },
      { text: 'Treinamentos', route: 'trainings.index' },
      { text: 'Relat. Treinamentos', route: 'training-reports.index' },
      { text: 'Produtos em destaque', route: 'store-highlights.index' },
    ],
  },
  {
    text: 'Pontos',
    icon: require('@/assets/icons/points.svg'),
    submenus: [
      { text: 'Câmbio', route: 'exchanges.index' },
      { text: 'Resgates', route: 'redemptions.index' },
    ],
  },
  // {
  //   text: 'Contato',
  //   icon: require('@/assets/icons/mail.svg'),
  //   submenus: [{ text: 'Mensagens enviadas' }],
  // },
  // {
  //   text: 'Api',
  //   icon: require('@/assets/icons/plug.svg'),
  //   submenus: [
  //     { text: 'Tokens gerados' },
  //     { text: 'Cargas enviadas' },
  //     { text: 'Usuários autorizados', route: 'api-users.index' },
  //   ],
  // },
  {
    text: 'Config.',
    icon: require('@/assets/icons/cog.svg'),
    submenus: [
      { text: 'Usuários', route: 'admins.index' },
      { text: 'Destinatários de Formulários', route: 'form-recipients.index' },
      { text: 'Taxas de envio Cartão', route: 'card-shipping-fees.index' },
      { text: 'Termos de aceitação', route: 'terms-of-acceptance.index' },
    ],
  },
];
